import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  inject,
  input,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { SafeHtmlPipe } from '../../pipes/safe-html-pipe';
import { Button } from 'primeng/button';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { TextResourcePipe } from '../../pipes/text-resource.pipe';
import { AsyncPipe, NgComponentOutlet } from '@angular/common';
import { TextResourceWithYearParamsPipe } from '../../pipes/text-resource-with-params.pipe';
import { ApplicationCode } from '../../enums/application_code';

@Component({
  selector: 'app-info-dialog',
  imports: [
    SafeHtmlPipe,
    Button,
    TextResourcePipe,
    AsyncPipe,
    NgComponentOutlet,
    TextResourceWithYearParamsPipe,
  ],
  templateUrl: './info-dialog.html',
  styleUrl: './info-dialog.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class InfoDialog implements AfterViewInit {
  protected readonly dynamicDialogRef = inject(DynamicDialogRef);

  protected header = input<string>();
  protected content = input<string>();
  protected component = input<any>();
  protected hideSubmitButton = input<boolean>();
  protected hideCancelButton = input<boolean>();
  protected scrollTo = input<string>();
  protected kodWniosku = input<ApplicationCode>();

  @ViewChild('scrollContainer') scrollContainer!: ElementRef<HTMLDivElement>;

  ngAfterViewInit() {
    const targetId: string | null = this.scrollTo() ?? null;
    if (targetId) {
      this.scrollToSection(targetId);
    }
  }

  private scrollToSection(id: string) {
    if (!this.scrollContainer) return;

    const container = this.scrollContainer.nativeElement;

    const target = container.querySelector<HTMLElement>(`#${id}`);
    if (!target) {
      return;
    }

    const offsetTop = target.offsetTop - container.offsetTop;
    target.classList.add('service-active');

    container.scrollTo({
      top: offsetTop - 8,
      behavior: 'smooth',
    });
  }
}
